import { render } from "./ContentViewer.vue?vue&type=template&id=1049f5ca&scoped=true"
import script from "./ContentViewer.vue?vue&type=script&lang=js"
export * from "./ContentViewer.vue?vue&type=script&lang=js"

import "./ContentViewer.vue?vue&type=style&index=0&id=1049f5ca&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1487974345/src/github.com/DeepAngle/DDR-Atlas-Proto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1049f5ca"]])

export default __exports__